import { useQuery } from "@tanstack/react-query";
import { playerApi, type PlayerProfile } from "./api";

export const profileQueryKey = (token: string) => ["player", token, "me"] as const;

/** The player's profile. No retries: an invalid link is a final answer, not a flaky one. */
export function usePlayerProfile(token: string) {
  return useQuery({
    queryKey: profileQueryKey(token),
    queryFn: () => playerApi.me(token),
    retry: false,
  });
}

/**
 * Applies a PATCH response to the cached profile. The PATCH view does not compute `locked`,
 * so the cached value is kept.
 */
export function mergeProfile(prev: PlayerProfile | undefined, next: PlayerProfile): PlayerProfile {
  return prev ? { ...next, locked: prev.locked } : next;
}
